// extracted by mini-css-extract-plugin
module.exports = {"other":"UnderwritingInfo_other__W1ZGe","tabs":"UnderwritingInfo_tabs__1_zWr"};